"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("../../../../../Button"));
var _Note = _interopRequireDefault(require("../../../../Notes/Note"));
var _TicketLogIconButton = _interopRequireDefault(require("../../../../Tickets/TicketLogIconButton"));
var _TimeFrom = _interopRequireDefault(require("../../../../Common/TimeFrom"));
var _TicketType = require("../../../../Tickets/TicketType");
var _iconsReact = require("../../../../../../icons-react");
var _constants = require("../../../../../../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var UPDATE_INTERVAL = 1 * 1000;
var TicketLog = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var avatarUrl = _ref.avatarUrl,
    className = _ref.className,
    id = _ref.id,
    message = _ref.message,
    name = _ref.name,
    onClickIcon = _ref.onClickIcon,
    onPin = _ref.onPin,
    onFlag = _ref.onFlag,
    onEdit = _ref.onEdit,
    isPinned = _ref.isPinned,
    time = _ref.time,
    type = _ref.type,
    value = _ref.value,
    valueText = _ref.valueText,
    editable = _ref.editable,
    editableExpiresAt = _ref.editableExpiresAt;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isHovered = _useState2[0],
    setHovered = _useState2[1];
  var toggleHover = function toggleHover(hoverState) {
    return setHovered(hoverState);
  };
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isEditing = _useState4[0],
    setEditing = _useState4[1];
  var toggleEditing = function toggleEditing() {
    return setEditing(!isEditing);
  };
  var isNotExpiredEditable = function isNotExpiredEditable() {
    return Boolean(editable && (editableExpiresAt ? editableExpiresAt * 1000 >= Date.now() : true));
  };
  var _useState5 = (0, _react.useState)(isNotExpiredEditable),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    isEditable = _useState6[0],
    setEditable = _useState6[1];
  var isFlagged = _constants.TICKET_LOG_TYPES.TASK === type;
  var handlePin = (0, _react.useCallback)(function () {
    onPin({
      id: id,
      isPinned: !isPinned,
      relateTo: _constants.LOG_RELATIONS.TICKET
    });
  }, [onPin]);
  var handleFlag = (0, _react.useCallback)(function () {
    onFlag({
      id: id,
      isFlagged: !isFlagged,
      relateTo: _constants.LOG_RELATIONS.TICKET
    });
  }, [onFlag]);
  var handleEdit = (0, _react.useCallback)(function (_ref2) {
    var changedValue = _ref2.value;
    onEdit({
      id: id,
      value: changedValue,
      relateTo: _constants.LOG_RELATIONS.TICKET
    });
  }, [onEdit]);
  (0, _react.useEffect)(function () {
    var interval = setInterval(function () {
      if (!isEditable) return;
      setEditable(isNotExpiredEditable());
    }, UPDATE_INTERVAL);
    return function () {
      return clearInterval(interval);
    };
  }, [isEditable, editableExpiresAt]);
  var Content;
  switch (type) {
    case _constants.TICKET_LOG_TYPES.CREATE:
      Content = 'Тикет создан';
      break;
    case _constants.TICKET_LOG_TYPES.MANAGER:
      Content = /*#__PURE__*/_react["default"].createElement(StyledTitle, null, /*#__PURE__*/_react["default"].createElement(StyledHighlight, null, valueText), "\u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D \u043E\u0442\u0432\u0435\u0442\u0441\u0432\u0435\u043D\u043D\u044B\u043C");
      break;
    case _constants.TICKET_LOG_TYPES.TASK:
    case _constants.TICKET_LOG_TYPES.NOTE:
      Content = /*#__PURE__*/_react["default"].createElement(StyledHead, null, /*#__PURE__*/_react["default"].createElement(StyledNoteContainer, null, /*#__PURE__*/_react["default"].createElement(_Note["default"], {
        id: id,
        onToggleEdit: toggleEditing,
        onEdit: handleEdit,
        readOnly: !isEditable,
        value: valueText
      })), !isEditing && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledFlagButton, {
        functional: true,
        title: isFlagged ? 'Отметить как заметку' : 'Отметить как задачу',
        onClick: handleFlag,
        visible: isHovered,
        active: isFlagged
      }, /*#__PURE__*/_react["default"].createElement(_iconsReact.Flag, {
        height: 15
      })), /*#__PURE__*/_react["default"].createElement(StyledPinButton, {
        functional: true,
        title: isPinned ? 'Открепить' : 'Закрепить',
        onClick: handlePin,
        visible: isHovered,
        active: isPinned
      }, /*#__PURE__*/_react["default"].createElement(_iconsReact.Pin, {
        height: 15
      }))));
      break;
    case _constants.TICKET_LOG_TYPES.TYPE:
      Content = _TicketType.TITLES[value];
      break;
    case _constants.TICKET_LOG_TYPES.NPS:
      Content = 'NPS запрошен';
      break;
    default:
      Content = valueText;
      break;
  }
  return /*#__PURE__*/_react["default"].createElement(StyledTicketLog, {
    className: className,
    key: id,
    type: type,
    onMouseEnter: function onMouseEnter() {
      return toggleHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return toggleHover(false);
    },
    isEditing: isEditing
  }, /*#__PURE__*/_react["default"].createElement(StyledTimeline, null, /*#__PURE__*/_react["default"].createElement(StyledIcon, {
    avatarUrl: avatarUrl,
    value: value,
    type: type,
    onClick: onClickIcon
  }), /*#__PURE__*/_react["default"].createElement(StyledTimelineLine, null)), /*#__PURE__*/_react["default"].createElement(StyledContent, null, Content, /*#__PURE__*/_react["default"].createElement(StyledAction, null, /*#__PURE__*/_react["default"].createElement(StyledHighlight, null, name), message), /*#__PURE__*/_react["default"].createElement(StyledTimeFrom, {
    time: time,
    full: true,
    extend: true
  })));
});
TicketLog.displayName = 'TicketLog';
var StyledHead = _styledComponents["default"].div.withConfig({
  displayName: "TicketLog__StyledHead",
  componentId: "sc-3g33pm-0"
})(["display:flex;"]);
var StyledTimeline = _styledComponents["default"].div.withConfig({
  displayName: "TicketLog__StyledTimeline",
  componentId: "sc-3g33pm-1"
})(["display:flex;flex-direction:column;margin-right:7px;position:relative;width:16px;"]);
var StyledTimelineLine = _styledComponents["default"].div.withConfig({
  displayName: "TicketLog__StyledTimelineLine",
  componentId: "sc-3g33pm-2"
})(["background-color:#c2c5cc;height:100%;margin:0 auto;width:1px;"]);
var StyledIcon = (0, _styledComponents["default"])(_TicketLogIconButton["default"]).withConfig({
  displayName: "TicketLog__StyledIcon",
  componentId: "sc-3g33pm-3"
})(["background-color:#e6e6e6;box-sizing:content-box;z-index:2;margin-top:1px;margin-bottom:5px;"]);
var StyledPinButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "TicketLog__StyledPinButton",
  componentId: "sc-3g33pm-4"
})(["opacity:0;outline:none;path{stroke:#919499;}", " :hover{path{stroke:#007aff;}}", ""], function (_ref3) {
  var visible = _ref3.visible;
  return visible && "\n    opacity: 1;\n  ";
}, function (_ref4) {
  var active = _ref4.active;
  return active && "\n    opacity: 1;\n    path { stroke: #17181A; }\n  ";
});
var StyledFlagButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "TicketLog__StyledFlagButton",
  componentId: "sc-3g33pm-5"
})(["outline:none;margin-right:10px;opacity:0;path{stroke:#919499;}", " :hover{path{stroke:#007aff;fill:#007aff;}}", ""], function (_ref5) {
  var visible = _ref5.visible;
  return visible && "\n    opacity: 1;\n  ";
}, function (_ref6) {
  var active = _ref6.active;
  return active && "\n    opacity: 1;\n    path {\n      stroke: #D0021B;\n      fill: #D0021B;\n    }\n  ";
});
var StyledContent = _styledComponents["default"].div.withConfig({
  displayName: "TicketLog__StyledContent",
  componentId: "sc-3g33pm-6"
})(["display:flex;flex:1;flex-direction:column;"]);
var StyledHighlight = _styledComponents["default"].span.withConfig({
  displayName: "TicketLog__StyledHighlight",
  componentId: "sc-3g33pm-7"
})(["color:#007aff;margin-right:3px;font-weight:normal;"]);
var StyledAction = _styledComponents["default"].div.withConfig({
  displayName: "TicketLog__StyledAction",
  componentId: "sc-3g33pm-8"
})(["display:flex;flex-wrap:wrap;font-size:12px;color:#919499;"]);
var StyledTitle = _styledComponents["default"].div.withConfig({
  displayName: "TicketLog__StyledTitle",
  componentId: "sc-3g33pm-9"
})(["flex:1;"]);
var StyledTimeFrom = (0, _styledComponents["default"])(_TimeFrom["default"]).withConfig({
  displayName: "TicketLog__StyledTimeFrom",
  componentId: "sc-3g33pm-10"
})(["color:#919499;"]);
var StyledTicketLog = _styledComponents["default"].div.withConfig({
  displayName: "TicketLog__StyledTicketLog",
  componentId: "sc-3g33pm-11"
})(["background-color:#e6e6e6;border-radius:4px;display:flex;flex-wrap:wrap;font-size:14px;padding:5px 10px;position:relative;width:100%;color:#4d4d4d;", ""], function (_ref7) {
  var type = _ref7.type,
    isEditing = _ref7.isEditing;
  return (type === _constants.TICKET_LOG_TYPES.NOTE || type === _constants.TICKET_LOG_TYPES.TASK) && "\n    z-index: ".concat(isEditing ? 5 : 1, ";\n    background: ").concat(type === _constants.TICKET_LOG_TYPES.TASK ? '#F9EAEC' : '#FFFBE5', ";\n    border-top: 1px solid #e6e6e6;\n    box-shadow: 0px 2px 2px rgb(230 230 230);\n\n    ").concat(StyledAction, " { color: #4D4D4D; }\n    ").concat(StyledIcon, " { background: ").concat(type === _constants.TICKET_LOG_TYPES.TASK ? '#F9EAEC' : '#FFFBE5', "; }\n    ").concat(StyledTimelineLine, " { background: #C8C7BF; }\n    ").concat(StyledTimeFrom, " { color: #4D4D4D; }\n  ");
});
var StyledNoteContainer = _styledComponents["default"].div.withConfig({
  displayName: "TicketLog__StyledNoteContainer",
  componentId: "sc-3g33pm-12"
})(["margin-bottom:5px;flex:1;"]);
var _default = exports["default"] = TicketLog;